import { createContext, useContext, useState } from 'react';

const StepTrackerContext = createContext();

export const useStepTracker = () => {
  const context = useContext(StepTrackerContext);
  if (!context) {
    throw new Error('useStepTracker must be used within StepTrackerProvider');
  }
  return context;
};

export const StepTrackerProvider = ({ children }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [completedSteps, setCompletedSteps] = useState(new Set());

  const completeStep = (stepId) => {
    setCompletedSteps((prev) => new Set([...prev, stepId]));
    if (stepId < steps.length && stepId === currentStep) {
      setCurrentStep(stepId + 1);
    }
  };

  const resetTracker = () => {
    setCurrentStep(1);
    setCompletedSteps(new Set());
  };

  const initializeFromActionPlan = (actionPlan) => {
    const newCompletedSteps = new Set();
    let nextStep = 1;

    // Step 1 and 2 completed if an ap exists
    if (actionPlan.id) {
      newCompletedSteps.add(1);
      nextStep = 2;
      newCompletedSteps.add(2);
      nextStep = 3;
    }

    // Step 3: completed if there's at lease 1 task
    if (actionPlan.tasksTotal > 0) {
      newCompletedSteps.add(3);
      nextStep = 4;
    }

    // Step 4: Completed only if all tasks have evidences and are set to closed
    const allTasksHaveEvidencesAndAreCompleted =
      actionPlan.tasksTotal > 0 &&
      actionPlan.tasksCompleted === actionPlan.tasksTotal;

    if (allTasksHaveEvidencesAndAreCompleted) {
      newCompletedSteps.add(4);
      nextStep = 5;
    }

    // Step 5: completed if the AP is closed
    if (actionPlan.status === true) {
      newCompletedSteps.add(5);
      nextStep = 5;
    }

    setCompletedSteps(newCompletedSteps);
    setCurrentStep(nextStep);
  };

  return (
    <StepTrackerContext.Provider
      value={{
        currentStep,
        steps,
        completedSteps,
        completeStep,
        resetTracker,
        initializeFromActionPlan,
      }}
    >
      {children}
    </StepTrackerContext.Provider>
  );
};

const steps = [
  {
    id: 1,
    title: 'Alcance',
    description:
      'El alcance te permite identificar en la estructura del negocio el plan de acción. Este paso te muestra el desempeño inicial del plan.',
  },
  {
    id: 2,
    title: 'Descripción',
    description:
      'Aquí debes ingresar una breve descripción, definir los tiempos o plazos para ejecutar el plan. También puedes definir una prioridad.',
  },
  {
    id: 3,
    title: 'Creación Tareas',
    description:
      'Crea tareas que te permitan avanzar estrategicamente con el plan. Asigna responsabe por tarea.',
  },
  {
    id: 4,
    title: 'Carga evidencias',
    description:
      'Carga evidencias de tus avances en cada tarea que te permitirán completar el plan y cerrarlo exitosamente',
  },
  {
    id: 5,
    title: 'Cierre',
    description:
      'Cierre el plan de forma exitosa, para que los usuarios involucrados reciban notificaciones.',
  },
];
